module.exports = __webpack_public_path__ + "static/media/unitedway.9647ec6f.md";